import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { CheckboxGroupField } from '../../../components/hook-form/form-checkbox-group.component';
import { Permission } from '../../../models/masters/permission';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { useFormContext } from 'react-hook-form';

interface RoleFormProps {
  permissionList: Permission[];
  editItem?: any;
}

export const RoleForm = ({ permissionList, editItem }: RoleFormProps) => {

  const { getValues } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item lg={12}>
        <FormInput
          label="Role Name"
          name="roleName"
          maxLength={150}
          autoFocus
        />
      </Grid>
      <Grid item lg={12}>
        <FormInput
          disabled={!!editItem?.roleID && editItem?.isSystemDefined}
          label="Role Code"
          name="roleCode"
          maxLength={150}
        />
      </Grid>
      <Grid item lg={12}>
        <FormInput label="Description" name="roleDescription" maxLength={150} />
      </Grid>
      <Grid item lg={12}>
        {editItem?.roleID && <FormCheckbox disabled label="System Defined" name="isSystemDefined" />}
      </Grid>
      <Grid item lg={12}>
        <CheckboxGroupField
          optionData={permissionList ?? []}
          name="rolePermissions"
          labelKey="permissionDescription"
          valueKey="permissionID"
          groupKey="permissionGroup"
          parentKey="viewPermissionIDs"
          roleCode={getValues('roleCode')}
        />
      </Grid>
    </Grid>
  );
};
